import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiArrowRight } from 'react-icons/fi';
import { BLOG_POSTS } from '../data/blogPosts';
import SEO from '../components/SEO';
import { useSettings } from '../context/SettingsContext';

const Blog = () => {
  const { nightDiscountPct, nightDiscountEnabled } = useSettings();
  return (
    <div data-testid="blog-page" className="pt-28 bg-[#F7F8FA]">
      <SEO
        title="Lonavala Villa Travel Guides &amp; Stories | Royal Garden Villas Blog"
        description="Insider tips, planning guides, and stories about private pool villas in Lonavala — family vacations, corporate offsites, pre-wedding events and more. From 10+ years of hosting."
        path="/blog"
      />
      {/* Hero */}
      <section className="py-12 md:py-16 bg-[#1B2432]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-[#F57C20] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Royal Garden Villas Blog</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl text-white font-light" style={{ fontFamily: "'Playfair Display', serif" }}>
            Travel Guides & <span className="text-[#F57C20] italic">Villa Stories</span>
          </h1>
          <p className="text-white/50 text-sm mt-3 max-w-lg">Insider tips, local guides, and planning advice from 10+ years of hosting in Lonavala.</p>
        </div>
      </section>

      {/* Posts Grid */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {/* Featured */}
          <Link to={`/blog/${BLOG_POSTS[0].slug}`} className="group block bg-white rounded-xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all mb-10">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="h-64 md:h-auto overflow-hidden">
                <img src={BLOG_POSTS[0].image} alt={BLOG_POSTS[0].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6 md:p-10 flex flex-col justify-center">
                <span className="text-[#F57C20] text-xs font-semibold uppercase tracking-wider">{BLOG_POSTS[0].category}</span>
                <h2 className="text-xl md:text-2xl text-[#1A1A2E] font-bold mt-2 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{BLOG_POSTS[0].title}</h2>
                <p className="text-[#6B7280] text-sm mb-4">{BLOG_POSTS[0].excerpt}</p>
                <div className="flex items-center gap-4 text-xs text-[#9CA3AF]">
                  <span className="flex items-center gap-1"><FiClock className="w-3 h-3" /> {BLOG_POSTS[0].readTime}</span>
                  <span>{BLOG_POSTS[0].date}</span>
                </div>
                <span className="text-[#F57C20] text-sm font-semibold mt-4 flex items-center gap-1 group-hover:gap-2 transition-all">Read Article <FiArrowRight className="w-4 h-4" /></span>
              </div>
            </div>
          </Link>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_POSTS.slice(1).map(post => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="group bg-white rounded-xl overflow-hidden border border-gray-100 hover:shadow-lg transition-all">
                <div className="h-48 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <span className="text-[#F57C20] text-[10px] font-semibold uppercase tracking-wider">{post.category}</span>
                  <h3 className="text-[#1A1A2E] text-base font-bold mt-2 mb-2 line-clamp-2" style={{ fontFamily: "'Playfair Display', serif" }}>{post.title}</h3>
                  <p className="text-[#6B7280] text-xs mb-3 line-clamp-2">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-[#9CA3AF]">
                    <span className="flex items-center gap-1"><FiClock className="w-3 h-3" /> {post.readTime}</span>
                    <span className="text-[#F57C20] font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">Read <FiArrowRight className="w-3 h-3" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 bg-[#1B2432] rounded-xl p-8 md:p-12 text-center">
            <h3 className="text-white text-xl mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Ready to Experience Lonavala?</h3>
            <p className="text-white/50 text-sm mb-6">Book a private pool villa{nightDiscountEnabled ? ` — Stay Longer, Pay Less: ${nightDiscountPct}% OFF from your 2nd night onwards!` : ' — instant confirmation when you book direct.'}</p>
            <Link to="/booking" className="bg-[#F57C20] text-white px-8 py-3.5 rounded-lg text-sm font-semibold inline-flex items-center gap-2 hover:bg-[#E06A10] transition-all">
              Book Now <FiArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
